import { render, staticRenderFns } from "./widgetNotFoundWidget.vue?vue&type=template&id=5bf335d5&scoped=true"
import script from "./widgetNotFoundWidget.vue?vue&type=script&lang=js"
export * from "./widgetNotFoundWidget.vue?vue&type=script&lang=js"
import style0 from "./widgetNotFoundWidget.vue?vue&type=style&index=0&id=5bf335d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf335d5",
  null
  
)

export default component.exports